import { render } from "./TakeRemarkDialog.vue?vue&type=template&id=12737ee5"
import script from "./TakeRemarkDialog.vue?vue&type=script&lang=js"
export * from "./TakeRemarkDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__